<template lang="pug">
    section#instacart-infographic.infographic
      .container
        .row
          .col-12.col-md-4.col-sm-12.infographic-item.infographic-col1
            #infographic-item1.infographic-item__col4.infographic-item__nobg
              h4 <i>$
                IOdometer(:value="itemValue1" :format="'(,ddd).dd'" :duration="2000") 
                |  billion</i> 
              p in shopper earnings<br/> <span>since March 2020</span>
            #infographic-item2.infographic-item__col4.infographic-item__bg.bg-orange
              h4 
                IOdometer(:value="itemValue2" :format="'(,ddd).dd'" :duration="2000") 
                | +
              p Active shoppers on <br/> the Instacart platform today
            #infographic-item3.infographic-item__col4.infographic-item__bg.bg-light-green
              h4 
                IOdometer(:value="itemValue3" :format="'(,ddd).dd'" :duration="2000") 
                | +
              p Instacart shoppers joined <br/> since March 2020
            #infographic-item7.infographic-item__col4.infographic-item__bg.bg-soft-green
              h4
                IOdometer(:value="itemValue6" :format="'(,ddd).dd'" :duration="2000") 
                | <span>million</span>+
              p Instacart investment for shopper health & safety since March 2020.
              
          .col-12.col-md-4.col-sm-12.infographic-item.infographic-col2
            #infographic-item4.infographic-item__col4.infographic-item__nobg
              .infographic-item__imageText
                img(v-lazy="imgUrl" alt="Instacart shopper delivery" width="352" height="292")
                //img(src="@/assets/images/infophrafics-image.png" alt="Instacart shopper delivery")
                //.infographic-item__imageText-container
                  p Lorem ipsum dolor sit amet, viverra
              h4
                IOdometer(:value="itemValue4" :format="'(,ddd).dd'" :duration="2000") 
                | +
              p health and safety kits 
                span since March 2020
            #infographic-item6.infographic-item__col4.infographic-item__bg.infographic-item__nobg
              h4
                IOdometer(:value="itemValue5" :format="'(,ddd).dd'" :duration="2000") 
                | %+
              p Year over year shopper earnings increase <span>since March 2020</span>

            //#infographic-item5.infographic-item__col4.infographic-item__nobg
              h4 +40%
              p YOY shopper earnings increase <span>since March 2020</span>
                  
          .col-12.col-md-4.col-sm-12.infographic-item.infographic-col3
            #infographic-item6.infographic-item__col4.infographic-item__bg.infographic-item__nobg
              h4
                IOdometer(:value="itemValue5" :format="'(,ddd).dd'" :duration="2000") 
                | %+
              p Year over year shopper earnings increase <span>since March 2020</span>
            #infographic-item7.infographic-item__col4.infographic-item__bg.bg-soft-green
              h4 $
                IOdometer(:value="itemValue6" :format="'(,ddd).dd'" :duration="2000") 
                | <span>million</span>+
              p Instacart investment in shopper health & safety since March 2020
            
</template>
<script>
//import { gsap } from 'gsap'
import IOdometer from 'vue-odometer';
import 'odometer/themes/odometer-theme-default.css';
import image from '@/assets/images/infophrafics-image.png'

export default{
  data(){
    return{
      cont: {val:0},
      newVal: 100,
      itemValue1: 1,
      itemValue2: 100,
      itemValue3: 200,
      itemValue4: 300,
      itemValue5: 10,
      itemValue6: 5,
      imgUrl: image
    }
  },
  components:{
    IOdometer
  },
  created(){
    this.$root.$refs.infophrafics = this;
  },
  mounted(){
  },
  methods: {
    transitionNumbers(){
      const that = this;
        setTimeout(() =>{
          that.itemValue1 = 4.2;
          that.itemValue2 = 500000;
          that.itemValue3 = 300000;
          that.itemValue4 = 750000;
          that.itemValue5 = 40;
          that.itemValue6 = 30;
        },500);
    }
  }
}
</script>
<style lang="scss">
  .infographic{
    position: relative;
    width: 100%;
    min-height: 75vh;
    height: auto;
    background: $white;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    @include respond-to('mobile'){
      padding: 1.5rem;
    }
    @include respond-to('small'){
      padding: 0;
    }
    &-item{
      &.col-md-4{
        @media (min-width: 768px) and (max-width: 1024px) {
          flex: 0 0 50%;
          max-width: 50%;
        }
      }
      &.infographic-col1{
        #infographic-item7{
          display: none;
          @media (min-width: 768px) and (max-width: 1024px) {
            display: block;
          }
        }
      }
      &.infographic-col2{
        #infographic-item6{
          display: none;
          @media (min-width: 768px) and (max-width: 1024px) {
            display: block;
          }
        }
      }
      &.infographic-col3{
        @media (min-width: 768px) and (max-width: 1024px) {
  
          /* CSS */
          display: none;
          
        }
      }
      &__col4{
        margin: 1rem 0;
      }
      &__nobg{
        background: transparent;
      }
      &__bg{
        border-radius: 30px;
        padding: 1rem 1rem 1rem 0;
        img{
          float: right;
        }
        &.bg-orange{
          background: $orange;
        }
        &.bg-light-green{
          background: $ligth_green;
        }
        &.bg-soft-green{
          background: $soft_green;
        }
      }
      &__imageText{
        position: relative;
        > img{
          width: 100%;
          height: auto;
          display: block;
          border-radius: 40px;
        }
        &-container{
          position: absolute;
          width: 100%;
          bottom: 0;
          left: 0;
          p{
            font-weight: 900;
            color: $white;
            font-size: 1.5rem;
            margin-bottom: 1rem;
            padding: 0 0.5rem; 
            line-height: 1.2; 
            @include respond-to('mobile'){
                font-size: 1.6rem;
            }
            @include respond-to('small'){
              font-size: 1rem;
            }
            @include respond-to('medium'){
              font-size: 1.8rem;
            }
          }
          img{
            float: right;
            width: 30px;
            height: auto;
            display: block;
            margin-top: 0;
            margin-right: 0;
            @include respond-to('mobile'){

            }
            @include respond-to('small'){
              width: 40px;
              margin-top: -10px;
              margin-right: 20px;
            }
            @include respond-to('medium'){
              width: 50px;
              margin-top: -10px;
              margin-right: 20px;
            }
          }
        }
      }
      #infographic-item1{
        h4{
          font-size: 2rem;
          font-weight: 900;
          color: $soft_green;
          margin: 0;
          text-align: center;
          @include respond-to('small'){
            font-size: 1.5rem;
            text-align: left;
          }
          @include respond-to('medium'){
            font-size: 2rem;
          }  
          br{
            display: none;
            @include respond-to('small'){
              display: block;
            }
          }
          i{
            font-size: 3rem;
            font-style: normal;
            line-height: 1;
            span{
              color: $soft_green;
              font-family: inherit;
              line-height: 0.9;
              top: -1px;
            }
            @include respond-to('mobile'){
              font-size: 4rem;
            }
            @include respond-to('small'){
              font-size: 3rem;
            }
            @include respond-to('medium'){
              font-size: 3.4rem;
            }
            @media screen and (min-width: 1200px){
              font-size: 4rem;
            }
          }  
        }
        p{
          font-size: 2rem;
          font-weight: 900;
          color: $soft_green;
          margin: 0;
          text-align: center;
          @include respond-to('small'){
            text-align: left;
          }
          span{
            color: $orange;
          }
        }
      }
      #infographic-item2, #infographic-item3{
        h4{
          font-size: 3.5rem;
          font-weight: 900;
          color: $white;
          margin: 0;
          line-height: 1;
          text-align: center;
          padding-left: 1rem;
          @include respond-to('mobile'){
            font-size: 3.4rem;
          }
          @include respond-to('small'){
            font-size: 2.6rem;
            text-align: left;
          }
          @include respond-to('medium'){
            font-size: 3.4rem;
          }
        }
        p{
          color: $white;
          padding-left: 1rem;
          font-weight: 900;
          margin: 0;
          text-align: center;
          @include respond-to('small'){
            text-align: left;
          }
        }
        img{
          width: 70px;
          height: auto;
          display: block;
          @include respond-to('mobile'){
            width: 90px;
          }
          @include respond-to('small'){
            width: 7vw;
          }
        }
      }
      #infographic-item3{
        h4{
          color: $green;
        }
        p{
          color: $green;
        }
      }
      #infographic-item4{
        h4{
          color: $orange;
          text-align: center;
          font-weight: 900;
          margin-top: 1rem;
          font-size: 4rem;
          @include respond-to('mobile'){
            font-size: 2.9rem;
          }
          @include respond-to('small'){
            font-size: 2.9rem;
            text-align: left;
          }
          @include respond-to('medium'){
            font-size: 2.8rem;
          }
          @media (width: 768px){
            font-size: 2.9rem;
          }
        }
        p{
          color: $soft_green;
          text-align: left;
          font-size: 1.5rem;
          line-height: 1.2;
          margin-bottom: 2rem;
          font-weight: 900;
          text-align: center;
          @include respond-to('small'){
            text-align: left;
          }
        }
        span{
          color: $orange;
        }
        hr{
          border-top: 1px solid $soft_green;
        }
      }
      #infographic-item5{
        display: flex;
        align-items: center;
        flex-flow: column;  
        @include respond-to('medium'){
          flex-flow: row;
        }
        h4{
          font-size: 4rem;
          font-weight: 900;
          color: $green;
          margin-right: 1rem;
          text-align: center;
          @include respond-to('small'){
            text-align: left;
          }
        }
        p{
          font-weight: 900;
          color: $soft_green;
          text-align: center;
          font-size: 1.5rem;
          @include respond-to('mobile'){
            text-align: left;
            font-size: 1rem;
          }
          span{
            color: $orange;
          }
        }
      }
      #infographic-item6{
        padding: 0.5rem 0;
        @include respond-to('mobile'){
          padding: 0.5rem 2rem;
        }
        @include respond-to('small'){
          padding: 0.5rem 1rem;
        }
        @include respond-to('medium'){
          padding: 0.5rem 2rem;
        }
        h4{
          font-size: 4rem;
          font-weight: 900;
          color: $soft_green;
          display: block;
          margin: 0;
          line-height: 1;
          text-align: center;
          @include respond-to('small'){
            font-size: 3rem; 
            text-align: left;
          }
          @include respond-to('medium'){
            font-size: 4rem;
          }
        }
        p{
          font-weight: 900;
          color: $orange;
          font-size: 1.5rem;
          line-height: 1.2;
          text-align: center;
          @include respond-to('small'){
            text-align: left;
          }
          span{
            color: $soft_green;
          }
          @include respond-to('mobile'){
            font-size: 1.25rem;
          }
          @include respond-to('small'){
            font-size: 1.25rem;
          }
          @include respond-to('medium'){
            font-size: 1.5rem;
          }
          img{
               width: 40px;
               height: auto;
               display: inline-block;
               float: inherit;
               @include respond-to('mobile'){
                 width: 55px;
               }
               @include respond-to('small'){
                 width: 70px;
               }
          }
        }
      }
      #infographic-item7{
        padding: 1rem 2rem;
        @include respond-to('small'){
          padding: 0.5rem 1rem;
        }
        @include respond-to('medium'){
          padding: 0.5rem 2rem;
        }
        h4{
          font-size: 3rem;
          font-weight: 900;
          color: $white;
          display: block;
          margin: 0;
          line-height: 1;
          text-align: center;
          @include respond-to('mobile'){
            font-size: 4rem;
          }
          @include respond-to('small'){
            font-size: 3rem; 
            text-align: left;
          }
          @include respond-to('medium'){
            font-size: 4rem;
          }
        }
        p{
          font-weight: 900;
          color: $white;
          font-size: 1.5rem;    
          line-height: 1.2;
          text-align: center;
          @include respond-to('mobile'){
            font-size: 1.75rem;
          }
          @include respond-to('small'){
            font-size: 1.5rem;
            text-align: left;
          }
        }
        img{
             width: 40px;
             height: auto;
             float: right;
             @include respond-to('mobile'){
               width: 55px;
             }
             @include respond-to('small'){
               width: 70px;
             }
        }
      }
    }
  }
  .odometer.odometer-auto-theme, .odometer.odometer-theme-default{
    font-family: inherit;
    line-height: 0.9;
  }
</style>
